import { analyticsDashboard as TYPES } from './../action_types';
import { dateParams as dateParamsUtil } from './utilities';

const RETRY_WAIT = 5 * 1000;

const fetch = function () {
  return function (dispatch, getState) {
    if (getState().AnalyticsDashboard.ReaderResearchInterests.meta.exhausted)
      return;
    if (getState().AnalyticsDashboard.ReaderResearchInterests.meta.fetching)
      return;

    dispatch({
      type: TYPES.FETCH_READER_RESEARCH_INTERESTS_REQUEST,
    });

    const dateParams = dateParamsUtil(
      getState().AnalyticsDashboard.DisplayedDates,
    );

    (function request() {
      // We dont cache this beause it could be processing the data still
      const queryParams = _.extend(
        { subdomain_param: 'api', user_id: Aedu.User.viewed.id },
        dateParams,
      );
      $.getJSON(
        $r.reader_research_interests_api_v0_user_stats_path(queryParams),
      )
        .done(function (readerResearchInterestsResponse) {
          if (readerResearchInterestsResponse.status === 'processing') {
            setTimeout(request, RETRY_WAIT);
            return;
          }

          dispatch({
            type: TYPES.FETCH_READER_RESEARCH_INTERESTS_SUCCESS,
            readerResearchInterests:
              readerResearchInterestsResponse.reader_research_interests,
          });
        })
        .fail(function () {
          dispatch({
            type: TYPES.FETCH_READER_RESEARCH_INTERESTS_FAILURE,
          });
        });
    })();
  };
};

const ReaderResearchInterests = {
  fetch: fetch,
};
export { ReaderResearchInterests };

const initialState = {
  perPageCounts: [],
  meta: {
    exhausted: false,
    fetching: false,
    errorFetching: false,
  },
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case TYPES.FETCH_READER_RESEARCH_INTERESTS_REQUEST:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: true,
        }),
      });

    case TYPES.FETCH_READER_RESEARCH_INTERESTS_SUCCESS:
      return Object.assign({}, state, {
        perPageCounts: state.perPageCounts.concat(
          action.readerResearchInterests,
        ),
        meta: Object.assign({}, state.meta, {
          fetching: false,
          exhausted: true,
          errorFetching: false,
        }),
      });

    case TYPES.FETCH_READER_RESEARCH_INTERESTS_FAILURE:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: false,
          errorFetching: true,
        }),
      });

    case TYPES.SET_DISPLAYED_DATES:
      return initialState;

    default:
      return state;
  }
};

export { reducer, reducer as default };
